import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { GlobalState } from "@/redux/slice/global/types";

const selectGlobal = (state: RootState): GlobalState => state?.global;

export default createDraftSafeSelector(selectGlobal, (global: GlobalState): any => global?.referer);
